"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _InnerWrapper = _interopRequireDefault(require("../assets/InnerWrapper.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Items = _interopRequireDefault(require("./Items"));

var _jsxFileName = "E:\\720\\720yun_tour_player\\src\\components\\dxc-scroll-menu\\src\\InnerWrapper.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_InnerWrapper["default"]);

var InnerWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(InnerWrapper, _React$PureComponent);

  function InnerWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      items: []
    });

    return _this;
  }

  var _proto = InnerWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var children = this.props.children;
    this.setState({
      items: children
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        translate = _this$props.translate,
        data = _this$props.data,
        renderItem = _this$props.renderItem,
        setItemRef = _this$props.setItemRef,
        dragging = _this$props.dragging,
        mounted = _this$props.mounted,
        selected = _this$props.selected,
        itemData = _this$props.itemData,
        setItemsWpRef = _this$props.setItemsWpRef;
    var transition = 0.1;
    var wrapperStyles = {
      transform: "translate3d(" + translate + "px, 0, 0)",
      transition: "transform " + (dragging || !mounted ? "0" : transition) + "s  ease-out",
      pointerEvents: dragging ? "none" : "all"
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("innerWrapperClass"),
      style: wrapperStyles,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("itemsWp"),
      ref: setItemsWpRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react["default"].createElement(_Items["default"], {
      itemData: itemData,
      selected: selected,
      renderItem: renderItem,
      data: data,
      setItemRef: setItemRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 11
      }
    })));
  };

  return InnerWrapper;
}(_react["default"].PureComponent);

var _default = InnerWrapper;
exports["default"] = _default;
module.exports = exports.default;